import { useEffect } from 'react';

const PPM_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_33bcf8e9-08ef-41f7-bae2-2f8d52c0ce23/artifacts/5m9yykej_Meet%20Mr.%20Fashion%2C%20Inc.%20%E2%80%94%20Private%20Placement%20Memorandum%203.pdf";

const PPMPage = () => {
  useEffect(() => {
    window.location.replace(PPM_URL);
  }, []);

  return (
    <div className="fixed inset-0 z-50 bg-[#0a0a0a] flex items-center justify-center" data-testid="ppm-page">
      <p className="text-gray-400 text-sm">Opening PPM document...</p>
    </div>
  );
};

export default PPMPage;
